import { useState, useCallback } from 'react';
import { OUTPUT_PRESETS } from '../config';
import { useTemplateContext } from '../context/TemplateContext';
import type { OutputSettings } from '../types';

/**
 * Manages output settings state.
 * Auto-selects the correct preset when the active template changes
 * (e.g. switching to YouTube Shorts auto-selects 1080×1920).
 */
export function useOutputSettings(): [OutputSettings, (s: OutputSettings) => void] {
  const { activeTemplate } = useTemplateContext();

  function defaultForTemplate(): OutputSettings {
    if (!activeTemplate) return OUTPUT_PRESETS.HD_30;
    const res = activeTemplate.metadata.resolution;
    if (res === '1080x1920') return OUTPUT_PRESETS.SHORTS_30;
    if (res === '1280x720')  return OUTPUT_PRESETS.SD_30;
    return OUTPUT_PRESETS.HD_30;
  }

  const [settings, setSettings] = useState<OutputSettings>(defaultForTemplate);

  const handleChange = useCallback((next: OutputSettings) => {
    setSettings(next);
  }, []);

  return [settings, handleChange];
}
